import { Component } from 'react';
import { Card, Text } from '@clockout-dev/design-elements';
import Inherit from '../../../core/inherit';
import ConfigurationCardController from './ConfigurationCard.controller';
import ConfigurationCardHeader from './elements/ConfigurationCardHeader';
import styles from './styles/configurationCard.module.scss';

/**
 * Card shell shared across the configuration steps. Toggle-building logic
 * lives in {@link ConfigurationCardController} (mixed in via {@link Inherit})
 * so the header stays a dumb presenter that just receives `action`.
 *
 * Props:
 * - `title`, `icon`, `description` — passed through to the header / body
 * - `enabled`, `onToggleEnabled` — drive the toggle's controlled state
 * - `toggleType: 'checkbox' | 'switch'` — controller picks the element
 * - `togglePosition: 'leading' | 'trailing'` — when `'leading'`, the toggle
 *   precedes the title and the icon block is skipped (Limits left column);
 *   otherwise the toggle sits in the header's `action` slot (Fee Structure)
 * - `disabled` — explicit override; otherwise inferred from `enabled === false`
 *
 * @extends {ConfigurationCardController}
 * @extends {Component}
 */
class ConfigurationCard extends Inherit(ConfigurationCardController, Component) {
    render() {
        const { description, children, title, icon} = this.props;
        const isDisabled = this.isCardDisabled();
        const action = this.buildToggleAction();
        const headerClassNames = this.buildHeaderClassNames();
        const cardClassName = this.buildCardClassName();
        const bodyClassName = this.buildBodyClassName();

        return (
            <Card className={cardClassName}>
                <ConfigurationCardHeader
                    classNames={headerClassNames}
                    title={title}
                    icon={icon}
                    action={action}
                />
                {description ? (
                    <Text as="span" size="xs" className={styles.cardHeaderDescription}>
                        {description}
                    </Text>
                ) : null}
                <div className={bodyClassName} aria-disabled={isDisabled || undefined}>
                    {children}
                </div>
            </Card>
        );
    }
}

export default ConfigurationCard;
